<!-- Export Certificate Format -->
<div class="export-certificate-container">
  <div class="certificate-page" *ngFor="let cert of displayData; let i = index">

    <!-- Title -->
    <div class="cert-title">
      <h1>EXPORT CERTIFICATE</h1>
    </div>

    <!-- Certificate Meta Info -->
    <div class="cert-meta">
      <div>CERTIFICATE NO. {{ cert.certificate_no || '' }}</div>
      <div>REFERENCE NUMBER: {{ cert.reference_number || '' }}</div>
    </div>

    <!-- Main Table (11 columns) -->
    <div class="cert-table-wrapper">
      <table class="cert-table">

        <!-- Row 1: Registration header labels -->
        <tr>
          <td class="c-lbl" colspan="3">Registration No.</td>
          <td class="c-lbl" colspan="3">Registration Date</td>
          <td class="c-lbl" colspan="2">First Reg. Date</td>
          <td class="c-lbl" colspan="3">Maker's serial number</td>
        </tr>

        <!-- Row 2: Registration data -->
        <tr>
          <td class="c-val c-lg" colspan="3">{{ cert.registration_no || '' }}</td>
          <td class="c-val c-lg" colspan="3">{{ cert.registration_date || '' }}</td>
          <td class="c-val c-lg" colspan="2">{{ cert.first_reg_date || '' }}</td>
          <td class="c-val c-lg" colspan="3">{{ cert.makers_serial_number || '' }}</td>
        </tr>

        <!-- Row 3: Trademark / Model / Engine headers -->
        <tr>
          <td class="c-lbl" colspan="4">Trademark of the maker of the vehicle</td>
          <td class="c-lbl" colspan="3">Model</td>
          <td class="c-lbl" colspan="2">Engine Model</td>
          <td class="c-lbl" colspan="1">Engine Number</td>
          <td class="c-lbl" colspan="1">Fuel</td>
        </tr>

        <!-- Row 4: Trademark / Model / Engine data -->
        <tr>
          <td class="c-val c-lg" colspan="4">{{ cert.trademark_maker || '' }}</td>
          <td class="c-val c-lg" colspan="3">{{ cert.model || '' }}</td>
          <td class="c-val c-lg" colspan="2">{{ cert.engine_model || '' }}</td>
          <td class="c-val c-lg" colspan="1">{{ cert.engine_no || '' }}</td>
          <td class="c-val c-lg" colspan="1">{{ cert.classification_of_fuel || '' }}</td>
        </tr>

        <!-- Row 5: Name of Owner -->
        <tr>
          <td class="c-lbl c-left" colspan="3">Name of Owner</td>
          <td class="c-val c-left" colspan="8">{{ cert.name_of_owner || '' }}</td>
        </tr>

        <!-- Row 6: Address of Owner -->
        <tr>
          <td class="c-lbl c-left" colspan="3">Address of Owner</td>
          <td class="c-val c-left" colspan="8">{{ cert.address_of_owner || '' }}</td>
        </tr>

        <!-- Row 7: Name of User -->
        <tr>
          <td class="c-lbl c-left" colspan="3">Name of User</td>
          <td class="c-val c-left" colspan="8">{{ cert.name_of_user || '' }}</td>
        </tr>

        <!-- Row 8: Address of User -->
        <tr>
          <td class="c-lbl c-left" colspan="3">Address of User</td>
          <td class="c-val c-left" colspan="8">{{ cert.address_of_user || '' }}</td>
        </tr>

        <!-- Row 9: Locality of principal abode of use -->
        <tr>
          <td class="c-lbl c-left" colspan="3">Locality of principal abode of use</td>
          <td class="c-val c-left" colspan="8">{{ cert.locality_principal_abode || '' }}</td>
        </tr>

        <!-- Row 10: Classification headers -->
        <tr>
          <td class="c-lbl" colspan="2">Classification of vehicle</td>
          <td class="c-lbl" colspan="1">Use</td>
          <td class="c-lbl" colspan="1">Purpose</td>
          <td class="c-lbl" colspan="1">Type of Body</td>
          <td class="c-lbl" colspan="1">Fixed Number</td>
          <td class="c-lbl" colspan="1">Maxim Carry</td>
          <td class="c-lbl" colspan="2">Weight</td>
          <td class="c-lbl" colspan="2">G/Weight</td>
        </tr>

        <!-- Row 11: Classification data -->
        <tr>
          <td class="c-val c-lg" colspan="2">{{ cert.classification_of_vehicle || '' }}</td>
          <td class="c-val c-lg" colspan="1">{{ cert.use || '' }}</td>
          <td class="c-val c-lg" colspan="1">{{ cert.purpose || '' }}</td>
          <td class="c-val c-lg" colspan="1">{{ cert.type_of_body || '' }}</td>
          <td class="c-val c-lg" colspan="1">{{ cert.fixed_number || '' }}</td>
          <td class="c-val c-lg" colspan="1">{{ cert.maximum_carry || '' }}</td>
          <td class="c-val c-lg" colspan="2">{{ cert.weight || '' }}</td>
          <td class="c-val c-lg" colspan="2">{{ cert.g_weight || '' }}</td>
        </tr>

        <!-- Row 12: Engine / Dimension headers -->
        <tr>
          <td class="c-lbl">Engine Capacity</td>
          <td class="c-lbl">Classification of fuel</td>
          <td class="c-lbl">Specification No.</td>
          <td class="c-lbl">Classification No.</td>
          <td class="c-lbl">Length</td>
          <td class="c-lbl">Width</td>
          <td class="c-lbl">Height</td>
          <td class="c-lbl">FF Weight</td>
          <td class="c-lbl">FR Weight</td>
          <td class="c-lbl">RF Weight</td>
          <td class="c-lbl">RR Weight</td>
        </tr>

        <!-- Row 13: Engine / Dimension data -->
        <tr>
          <td class="c-val c-lg">{{ cert.engine_capacity || '' }}</td>
          <td class="c-val c-lg">{{ cert.classification_of_fuel || '' }}</td>
          <td class="c-val c-lg">{{ cert.specification_no || '' }}</td>
          <td class="c-val c-lg">{{ cert.classification_no || '' }}</td>
          <td class="c-val c-lg">{{ cert.length || '' }}</td>
          <td class="c-val c-lg">{{ cert.width || '' }}</td>
          <td class="c-val c-lg">{{ cert.height || '' }}</td>
          <td class="c-val c-lg">{{ cert.f_weight || '' }}</td>
          <td class="c-val c-lg">{{ cert.fr_weight || '' }}</td>
          <td class="c-val c-lg">{{ cert.rf_weight || '' }}</td>
          <td class="c-val c-lg">{{ cert.r_weight || '' }}</td>
        </tr>

        <!-- Row 14: Export Scheduled Day -->
        <tr>
          <td class="c-lbl c-left" colspan="3">Export Scheduled Day</td>
          <td class="c-val c-left" colspan="8">{{ cert.export_scheduled_day || '' }}</td>
        </tr>

        <!-- Row 15: Remarks + Authorized Signature -->
        <tr>
          <td class="c-remarks" colspan="7">
            <div class="remarks-heading">REMARKS</div>
            <div class="remarks-body" *ngIf="cert.remarks">{{ cert.remarks }}</div>
            <div class="remarks-owner" *ngIf="cert.latest_owner_name_registration || cert.old_vehicle_registration_no">
              <div *ngIf="cert.old_vehicle_registration_no">{{ cert.old_vehicle_registration_no }}</div>
              <div *ngIf="cert.latest_owner_name_registration">
                <br>Latest Owner<br>{{ cert.latest_owner_name_registration }}
              </div>
              <div *ngIf="cert.date_of_application">
                <br>Date of Application {{ cert.date_of_application }}
              </div>
            </div>
          </td>
          <td class="c-signature" colspan="4">
            <div class="sig-label">AUTHORIZED SIGNATURE(S)</div>
            <div class="sig-stamp">
              <img *ngIf="settings?.logo" [src]="settings.logo" alt="Company Stamp" class="stamp-img">
              <div *ngIf="!settings?.logo" class="stamp-box">[STAMP]</div>
            </div>
          </td>
        </tr>

      </table>
    </div>

    <!-- Footer (outside table) -->
    <div class="cert-footer">
      <div class="footer-date">DATE: {{ cert.final_date || getCurrentDate() }}</div>
      <div class="footer-authority">
        DIRECTOR GENERAL OF THE DISTRICT TRANSPORT BUREAU OR DIRECTOR OF THE TRANSPORT
        BRANCH OF THE DISTRICT TRANSPORT BUREAU. MINISTRY OF LAND, INFRASTRUCTURE,
        TRANSPORT AND TOURISM, JAPAN
      </div>
      <div class="footer-governor">Governor of: {{ settings?.city || 'KOBE' }}</div>
    </div>

    <!-- Page Break (except for last record) -->
    <div class="page-break" *ngIf="i < displayData.length - 1"></div>

  </div>
</div>
